import React from 'react'
import { IconButton, Stack, useMediaQuery, useTheme } from '@mui/material'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import MidEnergyIconOffline from './icons/MidEnergyIconOffline'
import MidEnergyIconOnline from './icons/MidEnergyIconOnline'
import MidEnergyInconsistentIcon from './icons/MidEnergyInconsistentIcon'
import MidSessionOfflineIcon from './icons/MidSessionOfflineIcon'

interface MidMeterIconsProps {
  midMeterConnected: boolean
  midEnergyInconsistent: boolean
  midSessionOffline: boolean
}

/**
 * Component for displaying proper MID icons inside charging sessions
 * @param - midMeterConnected as boolean, value for MID icon
 * @param - midEnergyInconsistent as boolean, value for MID meter inconsistency icon
 * @param - midSessionOffline as boolean, value for MID meter offline icon
 */
export const MidMeterIcons: React.FC<MidMeterIconsProps> = ({ midMeterConnected, midEnergyInconsistent, midSessionOffline }) => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const midEnergyIcon = midMeterConnected ? <MidEnergyIconOnline /> : <MidEnergyIconOffline />

  const midEnergyTooltipTitleKey = midMeterConnected
    ? 'emobility.chargingSession.mid-meter-tooltip'
    : 'emobility.chargingSession.no-mid-meter-tooltip'

  return (
    <Stack direction={'row'} gap={2} alignItems={'center'}>
      <OptionalTooltipWrapper titleKey={midEnergyTooltipTitleKey} placement={downSm ? 'top' : 'bottom'}>
        {downSm ? (
          <IconButton
            color="inherit"
            onClick={e => {
              e.stopPropagation()
            }}
          >
            {midEnergyIcon}
          </IconButton>
        ) : (
          midEnergyIcon
        )}
      </OptionalTooltipWrapper>

      {midEnergyInconsistent && (
        <OptionalTooltipWrapper titleKey={'emobility.chargingSession.mid-meter-tooltip-inconsistent'} placement={downSm ? 'top' : 'bottom-start'}>
          {downSm ? (
            <IconButton
              color="inherit"
              onClick={e => {
                e.stopPropagation()
              }}
            >
              <MidEnergyInconsistentIcon />
            </IconButton>
          ) : (
            <MidEnergyInconsistentIcon />
          )}
        </OptionalTooltipWrapper>
      )}

      {midSessionOffline && (
        <OptionalTooltipWrapper titleKey={'emobility.chargingSession.mid-meter-tooltip-session-offline'} placement={downSm ? 'top' : 'bottom-start'}>
          {downSm ? (
            <IconButton
              color="inherit"
              onClick={e => {
                e.stopPropagation()
              }}
            >
              <MidSessionOfflineIcon />
            </IconButton>
          ) : (
            <MidSessionOfflineIcon />
          )}
        </OptionalTooltipWrapper>
      )}
    </Stack>
  )
}
